import { gql } from '@apollo/client';

const WET_DRY_TRY_ACTIVITY = gql`
  query wetDryTry($where: ActivityWhereInput!) {
    wetDryTry(where: $where) {
      title
      description
      book {
        id
        title
        characters {
          id
          character
          characterCase
          characterType
        }
      }
      activityType {
        name
      }
      activityTypeId
      url
    }
  }
`;

export default WET_DRY_TRY_ACTIVITY;
